export default {
    /* GET_LOCATIONS
    ---------------------------------------------------------------
    */
    GET_LOCATIONS: (state, data) => {
        state.localizations = data.results
    }
}